module.exports = __webpack_public_path__ + "static/animation-services-wifi-02f25dec270731e95a2aae3078a0eb92.png";